export const DEFAULT_DASHBOARD_READY_TIMEOUT_MS = 1500;

export const DEFAULT_DASHBOARD_READY_POLL_INTERVAL_MS = 50;
